<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                <img src="img/brand/logo_horizontal.png" alt="logo">
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                        <img src="img/brand/logo_horizontal.png" alt="logo">
                    </router-link>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
                <router-link slot="brand" class="navbar-brand mr-lg-5" to="/recuperacfdi">
                    <i class="ni ni-cloud-download-95 d-lg-none"></i>
                    <span class="nav-link-inner--text">  Reimprime tu factura</span>
                </router-link>
                <router-link slot="brand" class="navbar-brand mr-lg-5" to="/facturacion-e">
                    <i class="ni ni-ruler-pencil d-lg-none"></i>
                    <span class="nav-link-inner--text">  Facturacion en linea</span>
                </router-link>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>
<style>
</style>
